// Flat content-key defaults mirroring the `content` table shape (content_key -> content_value).
// Values shown here are the template copy; any row saved from edit mode overrides them.
export const defaultContent: Record<string, string> = {
  // Brand / header
  'company-logo': '/brand-logo.svg',
  'company-title': '盈紘有限公司',
  'company-title-en': 'Ying Hong Co., Ltd.',

  // Hero (#home)
  'hero-eyebrow': 'PRECISION IN EVERY DETAIL',
  'hero-edition': 'PRECISION SCREWS / SKD61',
  'hero-kicker': '多種規格，ISO 刀具刀片鎖固螺絲',
  'hero-heading-line1': '細節，',
  'hero-heading-line2': '成就',
  'hero-heading-accent': '關鍵。',
  'hero-intro-text': '多種既有規格的 SKD61 螺絲，依需求選購。\n既有規格不適用時，再評估特規製作。',
  'hero-principle':
    '憑藉多年 CNC 加工經驗與專業技術，本公司將重心聚焦於刀片鎖固螺絲產品的研發與供應，致力成為 CNC 業者值得信賴的合作夥伴。',
  'hero-cta-text': '探索產品',
  'hero-tag-label': '01 / SKD61 SCREW',
  'hero-tag-strong': 'SKD61',
  'hero-scroll-text': '向下探索',
  'hero-scroll-sub': 'SCROLL TO EXPLORE',
  'hero-quote': '每一個規格，都有存在的理由。',
  'hero-screw-image': '/insert-locking-screw.png',
  'hero-sparks-image': '/machining-sparks.png',

  // Products intro (#products)
  'products-section-eyebrow': '01 / OUR PRODUCTS',
  'products-section-tagline': '為需求而生，為細節而製。',
  'products-heading-line1': '多種規格，',
  'products-heading-accent': '精準選擇。',
  'benefit-1': '極佳的耐高溫能力與抗軟化能力',
  'benefit-2': '優異的高溫耐磨耗',
  'benefit-3': '抗疲勞高韌性，增加刀具切削穩定度',
  'products-visual-label': 'SKD61 / PRECISION SCREWS',
  'products-visual-note': '產品外觀與加熱均為視覺示意，不代表實際溫度、操作條件或製程',
  'spec-1-title': '既有規格選購',
  'spec-1-subtitle': 'EXISTING SPECIFICATIONS',
  'spec-1-description': '提供多種既有規格的 SKD61 螺絲，可依尺寸、用途與需求數量，前往產品目錄選購。',
  'products-button-text': '查看產品完整目錄',
  'products-link': '/products',
  'spec-2-title': '特規製作服務',
  'spec-2-subtitle': 'CUSTOM PRODUCTION',
  'spec-2-description':
    '若既有規格不適用，請提供圖面與使用需求，協調螺徑、長度、頭型、公差及加工要求，評估可行性與報價後按圖製作。',
  'spec-2-button-text': '了解特規訂購',
  'material-band-en': 'THE MATERIAL. THE DETAIL. THE DIFFERENCE.',
  'material-band-zh': '小零件。',
  'material-band-zh-accent': '大關鍵。',

  // Ordering (#ordering)
  'ordering-eyebrow': '02 / CUSTOM ORDERS',
  'ordering-tagline': '從圖面到交付，確認每一處細節。',
  'ordering-heading-line1': '特規訂購，',
  'ordering-heading-line2': '從圖面開始。',
  'ordering-intro': '依圖面評估加工需求，協調尺寸與公差。\n確認可行性、報價及交期後，安排製作。',
  'order-flow-title': '特規訂購流程',
  'order-step-1-title': '提供圖面',
  'order-step-1-description': '提供製作圖面、加工需求、數量與期望交期。',
  'order-step-2-title': '協調規格',
  'order-step-2-description': '確認尺寸、公差及加工要求，評估製作可行性。',
  'order-step-3-title': '確認報價',
  'order-step-3-description': '雙方確認圖面、製作規格、報價、數量與交期。',
  'order-step-4-title': '製作交付',
  'order-step-4-description': '依確認的訂單按圖製作，並按約定安排交付。',
  'inquiry-title': '特規詢價資料',
  'inquiry-subtitle': '請準備圖面與需求，協助評估製作可行性。',
  'order-button-text': '洽詢特規製作',
  'inquiry-field-1-title': '圖面與規格',
  'inquiry-field-1-description': '製作圖面、尺寸、公差及加工要求；尚未確定的細節請註明，供雙方討論。',
  'inquiry-field-2-title': '必要資訊',
  'inquiry-field-2-description': '需求數量、期望交期、聯絡人與聯絡方式。',
  'inquiry-field-3-title': '選填資訊',
  'inquiry-field-3-description': '使用情境、參考照片或補充說明。',
  'order-note': '特規製作的可行性、報價與交期，依圖面及需求評估後確認。',

  // Contact (#contact)
  'contact-eyebrow': '03 / GET IN TOUCH',
  'contact-tagline': '好的合作，從對話開始。',
  'contact-heading-line1': '下一個關鍵，',
  'contact-heading-line2': '從這裡開始',
  'contact-intro': '既有規格可前往產品目錄選購。\n如需特規製作，歡迎提供圖面與需求洽詢。',
  'contact-copy-button-text': '複製特規詢價清單',
  'inquiry-copy-template':
    '盈紘有限公司 Ying Hong Co., Ltd.｜SKD61 特規螺絲詢價\n【圖面與規格】\n製作圖面：\n尺寸與公差：\n加工要求：\n待協調事項：\n【必要資訊】\n需求數量：\n期望交期：\n聯絡人：\n聯絡電話／電子郵件：\n【選填資訊】\n使用情境／參考照片／補充說明：',
  'contact-phone': '聯絡電話待提供',
  'contact-email': '聯絡信箱待提供',
  'contact-address': '公司地址待提供',
  'contact-note': '正式聯絡資訊確認後更新。',

  // Catalog page (/products)
  'catalog-eyebrow': 'YING HONG / SKD61',
  'catalog-title': '產品目錄',
  'catalog-disclaimer': '',
  'catalog-bottom-text': '規格洽詢與特規製作',
  'catalog-bottom-cta-text': '聯絡盈紘',
};

export const getDefault = (key: string): string => defaultContent[key] ?? '';
